module.exports = __webpack_public_path__ + "img/Sugar Checking.96516cb7.svg";